import { useEffect } from 'react';
import usePoolState from '../../../context/pool/usePoolState';
import useLiquidityPools from '../../../hooks/web3/pools/useLiquidityPools';
import PoolOption from './PoolOption';

const PoolSelector = () => {
    const { liquidityPools: lockedPools } = useLiquidityPools();
    const {
        selectedLiquidityPool: selectedPool,
        setSelectedLiquidityPool: setSelectedPool,
    } = usePoolState();

    useEffect(() => {
        if (!selectedPool && lockedPools) {
            setSelectedPool(lockedPools[0]);
        }
    }, [lockedPools, selectedPool, setSelectedPool]);

    return (
        <div className='pool-selector'>
            {lockedPools
                ? lockedPools.map((pool) => <PoolOption key={pool.poolId} pool={pool} />)
                : null}
        </div>
    );
};

export default PoolSelector;
